import { memo } from 'react';

import { ColorPicker as AntColorPicker } from 'antd';
import type {
    Color,
    ColorPickerProps as AntColorPickerProps,
} from 'antd/es/color-picker';

import cls from './input-color-picker.module.css';

interface ColorPickerProps {
    isDisabled?: boolean;
    onChange?: (value: string) => void;
    value?: AntColorPickerProps['value'];
}

export const InputColorPicker = memo((props: ColorPickerProps) => {
    const { isDisabled = false, onChange, value } = props;

    const handleChange = (color: Color) => {
        onChange?.(color.toHexString());
    };

    return (
        <div className={cls.wrapper}>
            <AntColorPicker
                arrow={false}
                disabled={isDisabled}
                disabledAlpha
                onChange={handleChange}
                value={value ?? '#FFFFFF'}
            />
        </div>
    );
});

InputColorPicker.displayName = 'InputColorPicker';
